import React from 'react';
import { useForm } from 'react-hook-form';
import PageLabel from "./PageLabel";
import { useAuth } from "../context/AuthContext";
import BaseInput from "./BaseInput";
import BaseButton from "./BaseButton";
import chevronLeft from "../assets/fi_chevron-left.svg";
import { useNavigate, useLocation } from 'react-router-dom';
import backendApi from "../services/backendApi";

function Profile() {
    const { user, login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const backTo = location.state?.from;

    const { register, handleSubmit, setValue, watch,  setError, formState: { errors } } = useForm({
        defaultValues: {
            name: "",
            address: "",
            personCode: "",
            vatCode: "",
            companyCode: "",
            personType: 1
        }
    });

    React.useEffect(() => {
        if (user?.invoiceProps) {
            setValue("name", user.invoiceProps.name || "");
            setValue("address", user.invoiceProps.address || "");
            setValue("personCode", user.invoiceProps.personCode || "");
            setValue("vatCode", user.invoiceProps.vatCode || "");
            setValue("companyCode", user.invoiceProps.companyCode || "");
            setValue("personType", user.invoiceProps.personType || 1);
        }
    }, [user, setValue]);

    const onSubmit = async (data) => {
        try {
            const response = await backendApi.put('/api/update-user-profile', data, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            login(response.data.client);
        } catch (error) {
            const errorData = error.response.data;

            if (errorData.errors) {
                const normalizedErrors = errorData.errors.reduce((acc, { field, message }) => {
                    if (!acc[field]) acc[field] = message;
                    return acc;
                }, {});

                Object.entries(normalizedErrors).forEach(([field, message]) => {
                    setError(field, { type: 'server', message });
                });
            }

            return;
        }
    };

    const personType = watch("personType");

    return (
        <div className="userProfile pageContent">
            {backTo ? (
                <PageLabel
                    text={"Rekvizitai sąskaitoms"}
                    className="pageLabel__navBack"
                    icon={
                        <img
                            className="iconLeft"
                            src={chevronLeft}
                            alt=""
                            loading="lazy"
                            onClick={() => navigate(backTo)}
                            style={{ cursor: 'pointer', height: '24px' }}
                        />
                    }
            /> ) : (
                <PageLabel text={"Rekvizitai sąskaitoms"} />
            )}

            <div className={"invoicePropsContainer"}>
                <h3>Rekvizitai sąskaitoms</h3>
                <div className="tabs__headers">
                    <div
                        className={`tabs__tabHeader personTypeTab preOrder__leftTab ${personType === 1 ? "tabs__tabHeader--active" : ""}`}
                        onClick={() => setValue("personType", 1)}
                    >
                        Fizinis asmuo
                    </div>
                    <div
                        className={`tabs__tabHeader personTypeTab preOrder__rightTab ${personType === 2 ? "tabs__tabHeader--active" : ""}`}
                        onClick={() => setValue("personType", 2)}
                    >
                        Juridinis asmuo
                    </div>
                </div>

                <form onSubmit={handleSubmit(onSubmit)} className={"invoice-props"}>
                    <BaseInput
                        label={personType === 1 ? "Vardas ir pavardė" : "Įmonės pavadinimas"}
                        {...register("name")}
                        error={errors.name}
                    />
                    {personType === 2 && <BaseInput label={"Įmonės kodas"} {...register("companyCode")} error={errors.companyCode} />}
                    {personType === 2 && <BaseInput label={"PVM mokėtojo kodas"} {...register("vatCode")} error={errors.vatCode} />}

                    <BaseInput label={"Adresas"} {...register("address")} error={errors.address} />

                    {personType === 1 && <BaseInput label={"Veiklos kodas"} {...register("personCode")} error={errors.personCode} />}
                    {personType === 1 && <BaseInput label={"PVM mokėtojo kodas"} {...register("vatCode")} error={errors.vatCode} />}

                    <input type="hidden" {...register("personType")} />
                    <BaseButton text={"Išsaugoti"} type="submit" className={'baseButton--primary'}/>
                </form>
            </div>
        </div>
    );
}

export default Profile;